import { getLocalizedString } from '../../utils/i18n-utils';

const SUPPORTED_METHOD_KEYS = [
  'webauthn.enroll.supported.method.phone',
  'webauthn.enroll.supported.method.icloud',
  'webauthn.enroll.supported.method.chrome',
  'webauthn.enroll.supported.method.windows.hello',
  'webauthn.enroll.supported.method.usb.key',
];

export default function WebAuthnEnrollInfo() {
  return (
    <div>
      <p>{getLocalizedString('webauthn.enroll.description')}</p>
      <ul className="webauthn-supported-methods-list">
        {SUPPORTED_METHOD_KEYS.map((key) => (
          <li key={key}>
            <strong>{getLocalizedString(key)}</strong>
          </li>
        ))}
      </ul>
      <p>{getLocalizedString('webauthn.enroll.follow.instructions')}</p>
    </div>
  );
}
